import React from "react";
import { CheckCircle } from "lucide-react";
import "./EventRegistrationSuccessModal.css";

const EventRegistrationSuccessModal = ({
  isOpen,
  eventTitle,
  onViewEvent,
  onExplore,
}) => {
  if (!isOpen) return null;

  return (
    <div className="event-success-modal-overlay">
      <div className="event-success-modal-container">
        <div className="event-success-modal-content">
          <div className="event-success-icon-wrapper">
            <CheckCircle className="event-success-icon" size={64} />
          </div>

          <h2 className="event-success-title">
            Event Registration Complete! 🎉
          </h2>

          <p className="event-success-message">
            You've registered for <strong>"{eventTitle}"</strong>
          </p>

          <p className="event-success-subtitle">
            What would you like to do next?
          </p>

          <div className="event-success-buttons">
            <button
              className="event-success-btn event-success-btn-primary"
              onClick={onViewEvent}
            >
              View Event Details
            </button>

            <button
              className="event-success-btn event-success-btn-secondary"
              onClick={onExplore}
            >
              Explore More Events
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EventRegistrationSuccessModal;
